<script>
    export default {
        name: "CategoriesLogos",
        props: {
            activeIndex: {
                type: Number,
                required: true
            },
            logos: {
                type: Array,
                required: true
            }
        },
        methods: {
            onClick(index) {
                this.$emit('index', index);
            },
            renderWrapper(h, children) {
                return h('div', {
                    class: 'categories-logos'
                }, children)
            },
            renderItem(h, img, index) {
                const isActive = this.activeIndex === index;
                const color = img.data.attrs['data-color'] || '';
                return h('a', {
                    class: {
                        'is-active': isActive
                    },
                    style: {
                        color: color
                    },
                    attrs: {
                        href: 'javascript:'
                    },
                    on: {
                        click: e => { e.preventDefault(); this.onClick(index) }
                    }
                }, [img])
            }
        },
        render(h) {
            return this.renderWrapper(h, this.logos.map((logo, index) => this.renderItem(h, logo, index)))
        }
    }
</script>
